import { __read, __spreadArray } from "tslib";
import i18n from 'i18next';
import { addDays, parse } from 'date-fns';
import { isRoundTrip } from './components/AeroexpressPopup/utils';
import { format } from '../utils';
export var getPassengerPricesMap = function (travellers, services) {
    var pricesByPassengerMap = new Map();
    services.forEach(function (service) {
        var allowedPassengerIds = new Set(service.allowedPassengers.reduce(function (acc, ids) { return __spreadArray(__spreadArray([], __read(acc), false), __read(ids), false); }, []));
        allowedPassengerIds.forEach(function (passengerId) {
            var traveller = travellers.find(function (traveller) { return traveller.id === passengerId; });
            if (traveller) {
                var type = traveller.type;
                var supplierType = traveller.supplierTravellerType;
                if (!pricesByPassengerMap.has(type)) {
                    pricesByPassengerMap.set(type, { type: type, supplierType: supplierType, price: service.price });
                }
            }
        });
    });
    return __spreadArray([], __read(pricesByPassengerMap.values()), false);
};
export var getAeroexpressTripLabel = function (trip) {
    var departureDate = parse(trip.departureDate, 'HH:mm dd.MM.yyyy', new Date());
    var label = format(departureDate, 'dd.MM.yyyy');
    if (isRoundTrip(trip)) {
        label += " - ".concat(i18n.t('Aeroexpress:To'), " ").concat(format(addDays(departureDate, 30), 'dd.MM.yyyy'));
    }
    return label;
};
